import z from "zod";

/**
 * CriterioItemsSchema
 */

export const CriterioItemsSchema = z.object({
  idCriterioAvaliacaoFornecedor: z.coerce.number(),
  idItemAvaliacaoFornecedor: z.coerce.number().nullable(),
  descricao: z.coerce.string().nullable(),
  ordem: z.coerce.number().nullable(),
  nota: z.coerce.number().nullable(),
});

/**
 * AvaliacaoOrdemCompraSchema
 */

export const AvaliacaoOrdemCompraSchema = z.object({
  statusEntrega: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  statusNfEntrega: z.coerce.number().nullable().default(null),
  data: z.coerce.date().nullable().default(null),
  avaliadoPor: z.coerce.number().nullable().optional(),
  nroNotaFiscal: z.string().nullable().optional(),
  observacao: z.string().nullable().optional(),
  arquivo: z.instanceof(File).nullable().default(null),
  limparArquivo: z.boolean().default(false),
  arquivoBoleto: z.instanceof(File).nullable().default(null),
  limparArquivoBoleto: z.boolean().default(false),
  criterioItems: z.array(CriterioItemsSchema),
}).superRefine((data, ctx) => {
  if (data.statusEntrega === 1) {
    if (data.data === undefined || data.data === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Você deve preencher este campo!',
        path: ['data'],
      });
    }
  }

  if (data.statusNfEntrega === 1) {
    if (data.nroNotaFiscal === undefined || data.nroNotaFiscal === null || data.nroNotaFiscal.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Você deve preencher este campo!',
        path: ['nroNotaFiscal'],
      });
    }
  }

  data.criterioItems.forEach(x => {
    if (x.nota !== null && x.nota > 0 && x.nota < 3) {
      if (data.observacao === undefined || data.observacao === null || data.observacao.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Você deve preencher este campo!',
          path: ['observacao'],
        });
      }
    }
  });
});

/**
 * AvaliacaoOrdemCompraForm
 */

export type AvaliacaoOrdemCompraForm = z.infer<typeof AvaliacaoOrdemCompraSchema>;